import messages from './messages'
import reports from './reports'
import participants from './participants'
import profiles from './profiles'
import settings from './settings'
import users from './users'
import sessions from './sessions'

const reducers = {
    messages,
    reports,
    participants,
    profiles,
    settings,
    users,
    sessions
}

export default reducers



// WEBPACK FOOTER //
// ./src/store/reducers/index.js